import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { PersonalizeQuickGlanceViewDataModel } from '@omni/models/personalizeQuickGlanceViewModel';

const REQUIRED_SELECTION_COUNT = 4;

@Component({
  selector: 'personalize-quick-glance',
  templateUrl: 'personalize-quick-glance.html',
  styleUrls:['personalize-quick-glance.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalizeQuickGlanceComponent {

  @Input() viewData: PersonalizeQuickGlanceViewDataModel;
  public sectionHeader: IndSectionHeaderViewDataModel;
  private _isSaving = false;

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly translate: TranslateService,
  ) {}

  public ngOnInit() {
    this._buildSectionHeader();
  }

  public onSectionHeaderControlClick(id: string) {
    if (id !== 'save' || this._isSaving) return;
    this._isSaving = true;
    this.viewData.callbackEvent?.('save', id, this.viewData.data);
    this.modalCtrl.dismiss();
  }

  public onCheckboxClick(item) {
    if (item) {
      item.isChecked = !item.isChecked;
    }
    this._buildSectionHeader();
  }

  private _buildSectionHeader() {
    const checkedCount = this.viewData.data.filter(option => option.isChecked).length;
    const title = this.viewData.pageSectionHeader.title;
    this.sectionHeader = {
      ...this.viewData.pageSectionHeader,
      title: checkedCount ? `${title} (${checkedCount})` : title,
      doNotModifyTitleCase: true,
      controls: [{
        id: 'save',
        text: this.translate.instant('SAVE'),
        isDisabled: checkedCount !== REQUIRED_SELECTION_COUNT,
        align: 'right',
      }],
    };
  }

  trackById(index: number, item: any) { return item?.id || item?.ID || index; }
}
